export default __webpack_public_path__ + "static/media/blue6.fc51bdb3.png";